import { useHistoryInterceptor } from '@helpers/history';
import { Glitch } from '@components/helpers/Glitch';
import { useChatStore, useAppStore } from '@stores';
import { useTranslation } from 'react-i18next';

export function Navbar() {
  const { t } = useTranslation(undefined, { keyPrefix: 'Navbar' });
  const { setTab, tab, userData } = useAppStore();
  const { unreadChannels } = useChatStore();

  useHistoryInterceptor(() => {
    if (tab !== 'hub') { setTab('hub'); return true; }
    return false;
  }, { disabled: tab === 'hub' });

  const tabs = ['hub', 'navigation', 'arsenal', 'chat'];
  const hasUnread = unreadChannels.length > 0;

  if (tab === 'combat') return null;

  const canAccess = (tabKey: string) => {
    if (tabKey !== 'arsenal') return true;
    return userData.tutorials.includes('Combat');
  };

  return (
    <div className="nav-container text-mono">
      {tabs.map((tabKey) => (
        <button
          className={`${tab === tabKey && 'active'} nav-button nav-${tabKey}`}
          onClick={() => setTab(tabKey as any)}
          disabled={!canAccess(tabKey)}
          key={tabKey}
        >
          <Glitch disabled={tab !== tabKey}>{t(`Tabs.${tabKey}`)}</Glitch>

          {hasUnread && tabKey === 'chat' && (
            <div className="chat-unread-notification" />
          )}

          <div className={`${tab === tabKey && 'is-active'} nav-indicator`} />
        </button>
      ))}
    </div>
  );
}

export default Navbar;